module.exports = __webpack_public_path__ + "img/home-top-image.8d3ab541.png";